// Routing.js

// routes.js

import { APP_BASE_URL } from 'firebaseConfig';
import { SectionType } from 'utilities/Enums';

export const PUBLIC_APP_ORIGIN = APP_BASE_URL;

export const STUDIO_BASE_PATH = '/studio';

export const SECTION_PATHS = {
  [SectionType.HOME]: '/',
  [SectionType.STUDIO]: STUDIO_BASE_PATH,
  [SectionType.FAVORITES]: '/favorites',
  [SectionType.TRASH]: '/trash',
  [SectionType.SEARCH]: '/search',
  [SectionType.SOURCE]: '/source',
  [SectionType.WATCH]: '/watch',
  [SectionType.API]: '/api',
  [SectionType.INBOX]: '/inbox',
  [SectionType.CALENDAR]: '/schedule',
  [SectionType.SCHEDULE]: '/schedule',
  [SectionType.CHANNELS]: '/channels',
  [SectionType.LIBRARY]: '/library',
  [SectionType.NOTIFICATIONS]: '/notifications',
  [SectionType.SETTINGS]: '/settings',
};

export const NODE_BASE_PATH = '/node';
export const PAGE_BASE_PATH = '/page';
export const USER_BASE_PATH = '/user';
export const BASE_PROFILE_BASE_PATH = '/base';

export const buildNodePath = (nodeKey) => `${NODE_BASE_PATH}/${encodeURIComponent(nodeKey)}`;

export const buildAbsoluteNodeUrl = (nodeKey, origin = PUBLIC_APP_ORIGIN) => {
  const cleanOrigin = String(origin || PUBLIC_APP_ORIGIN)
    .trim()
    .replace(/\/+$/, '');
  const cleanNodeKey = String(nodeKey || '').trim();

  if (!cleanNodeKey) return cleanOrigin;
  return `${cleanOrigin}${buildNodePath(cleanNodeKey)}`;
};

export const buildProfilePath = (profileKey) =>
  profileKey ? `${USER_BASE_PATH}/${encodeURIComponent(profileKey)}` : USER_BASE_PATH;

export const buildBaseMemberProfilePath = (baseKey, memberId) => {
  const normalizedBaseKey = String(baseKey || '').trim();
  const normalizedMemberId = String(memberId || '').trim();

  if (!normalizedBaseKey || !normalizedMemberId) {
    return BASE_PROFILE_BASE_PATH;
  }

  return `${BASE_PROFILE_BASE_PATH}/${encodeURIComponent(normalizedBaseKey)}/profile/${encodeURIComponent(normalizedMemberId)}`;
};

export function getSectionPath(section, options = {}) {
  if (section === SectionType.USER && options.baseKey && options.memberId) {
    return buildBaseMemberProfilePath(options.baseKey, options.memberId);
  }

  if (section === SectionType.USER && options.profileKey) {
    return buildProfilePath(options.profileKey);
  }

  if (section === SectionType.NODE && options.nodeKey) {
    return buildNodePath(options.nodeKey);
  }

  const path = SECTION_PATHS[section];
  return path || SECTION_PATHS[SectionType.HOME];
}

export function isStudioPath(pathname) {
  if (!pathname) return false;
  if (pathname === STUDIO_BASE_PATH) return true;
  return pathname.startsWith(`${STUDIO_BASE_PATH}/`);
}

export function inferSectionFromPath(pathname) {
  if (!pathname || pathname === '/' || pathname === '') {
    return SectionType.HOME;
  }

  if (isStudioPath(pathname)) {
    return SectionType.STUDIO;
  }

  if (pathname.startsWith(`${NODE_BASE_PATH}/`)) {
    return SectionType.NODE;
  }

  if (pathname === '/source' || pathname.startsWith('/source/')) {
    return SectionType.SOURCE;
  }

  if (pathname === '/watch' || pathname.startsWith('/watch/')) {
    return SectionType.WATCH;
  }

  if (pathname === PAGE_BASE_PATH || pathname.startsWith(`${PAGE_BASE_PATH}/`)) {
    return SectionType.API;
  }

  if (pathname === USER_BASE_PATH || pathname.startsWith(`${USER_BASE_PATH}/`)) {
    return SectionType.USER;
  }

  if (pathname.startsWith(`${BASE_PROFILE_BASE_PATH}/`)) {
    return SectionType.USER;
  }

  if (pathname.startsWith(`${USER_BASE_PATH}/`)) {
    return SectionType.USER;
  }

  if (
    pathname === '/schedule'
    || pathname.startsWith('/schedule/')
    || pathname === '/calendar'
    || pathname.startsWith('/calendar/')
  ) {
    return SectionType.SCHEDULE;
  }

  const match = Object.entries(SECTION_PATHS).find(([, basePath]) => {
    if (basePath === '/') return false;
    if (basePath === '/calendar' || basePath === '/schedule') return false;
    if (pathname === basePath) return true;
    return pathname.startsWith(`${basePath}/`);
  });

  return match ? match[0] : null;
}
